import theme from "@/styles/theme";
import IosShareIcon from "@mui/icons-material/IosShare";
import { Button } from "@mui/material";
import { grey } from "@mui/material/colors";

export const SharePlaylistButton = ({ onClick }) => {
  const style = {
    paddingLeft: 1,
    paddingRight: 1,
    color: grey[600],
    fontSize: "0.875rem",
    minWidth: "unset",
    "&.MuiButton-startIcon": {
      marginRight: "0.25rem",
    },
    [theme.breakpoints.only("xs")]: {
      transform: "translateY(-0.125rem)",
    },
    "& .share-button-text": {
      [theme.breakpoints.up("xs")]: {
        display: "none",
      },
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
    },
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  };

  return (
    <Button
      startIcon={<IosShareIcon />}
      onClick={onClick}
      aria-label="Playlist teilen"
      sx={style}
      disableRipple
    >
      <span className="share-button-text">Playlist teilen</span>
    </Button>
  );
};
